// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"530":"8e3da9b6","7100":"99ee7dd7","7887":"6de7cd5b","9669":"03d19a4c"}[chunkId] + ".chunk.css";
};